import React, { Component, Fragment } from "react";
import { Button, FormGroup, FormControl } from "react-bootstrap";
import "./App.css";
import DocumentSync from "./DocumentSync.jpg";
import LogoImage from "./Images/hunterdonlogo.jpg";
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator } from "react-tabulator";
import config from "./config";
import Popup from "reactjs-popup";

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      templates: [],
      columns: [],
      selectedTemplate: "",
      search: {},
      results: [],
      username: "",
      password: "",
      loggedInUser: "",
      token: "",
      refreshToken: "",
      viewerOpen: false,
      hasSearched: false,
    };
    this.openViewer = this.openViewer.bind(this);
    this.closeViewer = this.closeViewer.bind(this);
    this.viewFile = this.viewFile.bind(this);
  }

  async componentDidMount() {
    const CryptoJS = require("crypto-js");

    const SECRET_KEY = "mybossnameisRobertRisberg"; // Use a strong key, but remember it's hardcoded here.
    const encryptedUsername =
      "U2FsdGVkX1+VDsQTSzratyKfCgoeXFx1b7Va8ys3dIZj4Kz2q+TTDrRn9hRBChSFF5d37XIHOsB++vn68LApnw==";
    const encryptedPassword = "U2FsdGVkX187+5fNmrKBW4nUp4sV3tiz9rGNuNLf/n8=";

    const bytesUsername = CryptoJS.AES.decrypt(encryptedUsername, SECRET_KEY);
    const username = bytesUsername.toString(CryptoJS.enc.Utf8);

    const bytesPassword = CryptoJS.AES.decrypt(encryptedPassword, SECRET_KEY);
    const password = bytesPassword.toString(CryptoJS.enc.Utf8);

    this.setState(
      {
        username,
        password,
      },
      async () => await this.login()
    );
  }

  login = async (event) => {
    if (event) event.preventDefault();

    // Resetting the state
    this.setState({
      templates: [],
      columns: [],
      selectedTemplate: "",
      search: {},
      results: [],
      token: "",
      refreshToken: "",
    });

    const url = `${config.FoveonicsAPI}/api/authentication/SignInViewer`;

    try {
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: this.state.username,
          password: this.state.password,
        }),
      });

      const raw = await response.text(); // e.g.  "<ID>|<RT>"

      if (raw) {
        const [idToken, refreshToken] = raw.split("|");

        this.setState({
          token: idToken ?? "",
          refreshToken: refreshToken ?? "",
          loggedInUser: this.state.username,
        });

        this.loadTemplates();
      }
    } catch (error) {
      console.error("Error during login:", error);
      // You can also set an error message in the state to display it to the user
      this.setState({ loginError: "Failed to log in. Please try again." });
    }
  };

  getAuthHeader() {
    return { headers: { Authorization: `Bearer ${this.state.token}` } };
  }

  async loadTemplates() {
    let url = `${config.FoveonicsAPI}/api/Templates/`;
    fetch(url, this.getAuthHeader())
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          console.log(
            `Available templates: ${data.map((t) => t.displayName.trim())}`
          );
          this.setState({ templates: data });

          //load search controls for first template in the list
          this.loadSearchControls(data[0].tableName);
        }
      });
  }

  onTemplateChange = async (event) => {
    let options = event.target.options;
    let tableName = options[options.selectedIndex].value;
    this.loadSearchControls(tableName);
  };

  async loadSearchControls(tableName) {
    console.log(`Selected template table name: ${tableName}`);
    //set current template and clear search object
    this.setState({
      search: {},
      selectedTemplate: tableName,
      results: [],
      columns: [],
    });
    let url = `${config.FoveonicsAPI}/api/Templates/${tableName}/`;
    fetch(url, this.getAuthHeader())
      .then((res) => res.json())
      .then((data) => {
        console.log(`Template columns: ${data.map((c) => c.InputName.trim())}`);
        const filteredData = this.filterControlledList(data);
        this.setState({ columns: filteredData });
      });
  }

  filterControlledList(data) {
    return data.map((column) => {
      // Only modify columns with InputName "Document Type"
      if (
        column.InputName?.trim() === "Document Type" &&
        column.ControlledList &&
        Array.isArray(column.ControlledList) &&
        column.ControlledList.includes("PROPERTY INFORMATION")
      ) {
        // Create a modified copy with only "PROPERTY INFORMATION" in the list
        return {
          ...column,
          ControlledList: ["PROPERTY INFORMATION"],
        };
      }

      // Return original column for all other cases
      return column;
    });
  }

  search = async (event) => {
    event.preventDefault();
    const search = this.state.search ?? {};
    const searchWithDocType = {
      ...search,
      "Document Type": "PROPERTY INFORMATION", // This will override any existing value
    };

    const searchQueryString = Object.keys(searchWithDocType)
      .map((key) => `${key}=${encodeURIComponent(searchWithDocType[key])}`)
      .join("&");
    console.log(`Search query string: ${searchQueryString}`);
    let url = `${config.FoveonicsAPI}/api/Templates/${this.state.selectedTemplate}/search?${searchQueryString}`;
    console.log(`Search url: ${url}`);
    fetch(url, this.getAuthHeader())
      .then((res) => res.json())
      .then((data) => {
        console.log(`Search results: ${JSON.stringify(data)}`);
        console.log(`Search results: ${data}`);
        this.setState({ results: data, hasSearched: true });
      });
  };

  resetSearch = () => {
    this.setState({
      search: {}, // Clear search fields
      results: [], // Clear search results
    });
  };

  handleSearchChange = (event) => {
    const { id, value } = event.target;
    let search = this.state.search ?? {};
    if (!value) {
      delete search[id];
    } else {
      search[id] = value;
    }
    this.setState({ search: search });
  };

  async download(e, cell) {
    const rowData = cell.getRow().getData();
    let fileId = rowData.FileId;
    let url = `${config.FoveonicsAPI}/api/Files/${fileId}`;
    console.log(`Search url: ${url}`);
    const response = await fetch(url, this.getAuthHeader());
    if (!response.ok) {
      throw new Error(`Download failed with status ${response.status}`);
    }

    const contentDisposition = response.headers.get("content-disposition");
    const dispositionFilename = contentDisposition
      ?.split(";")
      .map((part) => part.trim())
      .find((part) => part.toLowerCase().startsWith("filename="))
      ?.replace(/^filename=/i, "")
      .trim();
    let filename = dispositionFilename || rowData.FileName || `file-${fileId}`;
    filename = filename.replace(/['"]+/g, ""); //trim double or single quotes - some pdfs with spaces in the filename needed this.
    const blob = await response.blob();
    var a = document.createElement("a");
    a.href = window.URL.createObjectURL(blob);
    a.download = filename;
    document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
    a.click();
    a.remove(); //afterwards we remove the element again
  }

  renderHeader() {
    return (
      <div id="header">
        {/* <a href="https://www.bridgewaternj.gov/">
          <img src={Bridgewater} alt="Bridgewater" />
        </a> */}
        {/* <a href="https://www.holmdeltownship-nj.com/">
          <img src={Holmdel} alt="Holmdel" />
        </a> */}
        {/* <a href="https://www.princetonnj.gov/">
          <img src={Princeton} alt="Princeton" />
        </a>*/}
        <a href="https://www.co.hunterdon.nj.us/">
          <img src={LogoImage} alt="hunterdon" />
        </a>
        <div id="login">
          {/* <form onSubmit={this.login}>
            <span>Username:</span>
            <input
              id="username"
              type="text"
              value={this.state.username}
              onChange={(e) => this.setState({ username: e.target.value })}
            />
            <span>Password:</span>
            <input
              id="password"
              type="password"
              value={this.state.password}
              onChange={(e) => this.setState({ password: e.target.value })}
            />
            <input type="submit" value="Submit" />
          </form> */}
        </div>
      </div>
    );
  }

  openViewer() {
    const viewerUrl = config.ImageViewer;

    // detect mobile / small screen
    const isMobile = window.innerWidth <= 768;

    if (isMobile) {
      window.open(viewerUrl, "_blank", "noopener,noreferrer");
      return;
    }

    // desktop/tablet → open popup iframe
    this.setState({ viewerOpen: true });
  }

  closeViewer() {
    this.setState({ viewerOpen: false });
  }

  async viewFile(e, cell) {
    try {
      // prevent duplicate triggers
      e.preventDefault();
      e.stopPropagation();
      if (this.isViewerOpening) return;
      this.isViewerOpening = true;
      setTimeout(() => (this.isViewerOpening = false), 1500);

      const row = cell.getRow().getData();
      const fileId = row.FileId;
      const fileName = row.FileName;
      const userEmailId = this.state.username;
      const targetOrigin = config.ImageViewer;
      const refreshToken = this.state.refreshToken;
      const clientId = "";
      const message = {
        refreshToken: refreshToken,
        fileId: fileId,
        editIndex: false,
        manageRedaction: false,
        deletePages: false,
        textSearch: false,
        fileName: fileName,
        userEmailId: userEmailId,
        managePii: false,
        clientId: "",
        printWithAnnotations: false,
      };

      const isMobile = window.innerWidth <= 768;

      // ======================================================
      // MOBILE: strict single-tab mode
      // ======================================================
      if (isMobile) {
        const viewerUrl = `${config.ImageViewer}?fileId=${encodeURIComponent(
          fileId
        )}&fileName=${encodeURIComponent(
          fileName
        )}&clientId=${encodeURIComponent(
          clientId
        )}&userEmailId=${encodeURIComponent(
          userEmailId
        )}&refreshToken=${encodeURIComponent(refreshToken)}`;

        if (!window.__mobileViewerTab || window.__mobileViewerTab.closed) {
          window.__mobileViewerTab = window.open(
            viewerUrl,
            "mobileViewerTab",
            "noopener,noreferrer"
          );
          console.log("Viewer opened (mobile):", viewerUrl);
        } else {
          window.__mobileViewerTab.focus();
          console.log("Reused existing viewer tab (mobile)");
        }

        return; // skip iframe flow
      }

      // ======================================================
      // DESKTOP: iframe postMessage (ensure popup is rendered first)
      // ======================================================
      // open the popup first
      this.openViewer();

      // wait for popup + iframe to exist before binding
      setTimeout(() => {
        const imageViewer = document.getElementById("imageViewer");
        if (!imageViewer) {
          console.error("imageViewer iframe not found after openViewer()");
          return;
        }

        imageViewer.onload = null; // clear old handlers

        if (imageViewer.attachEvent) {
          imageViewer.attachEvent("onload", function () {
            imageViewer.contentWindow.postMessage(
              JSON.stringify(message),
              targetOrigin
            );
          });
        } else {
          imageViewer.onload = function () {
            imageViewer.contentWindow.postMessage(
              JSON.stringify(message),
              targetOrigin
            );
          };
        }

        // always assign src after binding
        imageViewer.src = config.ImageViewer;
        console.log("Viewer opened (desktop iframe)");
      }, 300); // give React time to render popup
    } catch (err) {
      console.error("Error in viewFile:", err);
    }
  }

  renderNoResults() {
    return (
      <div
        style={{
          padding: "16px",
          color: "yellow", // red
          fontWeight: "bold",
          fontSize: "16px",
          textAlign: "center",
        }}
      >
        No results found
      </div>
    );
  }

  renderSearchResults() {
    const { results, hasSearched, columns } = this.state;

    // Do not show anything before the first Search click
    if (!hasSearched) return null;

    // After search: show "No results found" only when results are empty
    if (!Array.isArray(results) || results.length === 0) {
      return this.renderNoResults();
    }

    return (
      <Fragment>
        <ReactTabulator
          columns={[]
            .concat({
              formatter: () => "<a href='#'>Download</a>",
              width: 100,
              align: "center",
              cellClick: this.download.bind(this),
            })
            .concat({
              title: "File Name",
              field: "FileName",
              formatter: (cell) => {
                const v = cell.getValue() ?? "";
                return `<a href="#" class="file-link">${v}</a>`;
              },
              editor: "input",
              cellClick: (e, cell) => {
                this.viewFile(e, cell);
              },
            })
            .concat(
              (columns || []).map((c) => {
                return { title: c.InputName, field: c.InputName };
              })
            )}
          data={results}
          options={{ pagination: "local", paginationSize: 20 }}
        />
      </Fragment>
    );
  }

  displayTemplateSearchDescription() {
    const descriptions = config.templateSearchDescription;
    if (
      this.state.loggedInUser &&
      this.state.selectedTemplate &&
      descriptions &&
      descriptions[this.state.loggedInUser] &&
      descriptions[this.state.loggedInUser][this.state.selectedTemplate]
    ) {
      return (
        <div style={{ margin: "10px 0 0 10px", color: "#444" }}>
          {descriptions[this.state.loggedInUser][this.state.selectedTemplate]}
        </div>
      );
    }
  }

  render() {
    return (
      <Fragment>
        <div id="app-container">
          {this.renderHeader()}
          {this.state.token && (
            <div className="SearchDocumentSync">
              <div className="left">
                <b>Records to be searched:</b>&nbsp;
                <select id="templates" onChange={this.onTemplateChange}>
                  {this.state.templates.map((template) => (
                    <option key={template.tableName} value={template.tableName}>
                      {template.displayName.trim()}
                    </option>
                  ))}
                </select>
                {this.displayTemplateSearchDescription()}
                <form onSubmit={this.search} id="searchControls">
                  {this.state.columns.map((column) => (
                    <FormGroup
                      controlId={column.InputName}
                      key={column.InputName}
                    >
                      <label>{column.InputName}:</label>
                      {column.ControlledList ? (
                        <select
                          id={column.InputName}
                          onChange={this.handleSearchChange}
                          className="custom-select"
                          value={this.state.search[column.InputName] || ""}
                        >
                          {[""]
                            .concat(
                              column.ControlledList.slice().sort((a, b) =>
                                a.localeCompare(b)
                              )
                            )
                            .map((item) => (
                              <option key={item} value={item}>
                                {item}
                              </option>
                            ))}
                        </select>
                      ) : (
                        <FormControl
                          value={this.state.search[column.InputName] || ""}
                          onChange={this.handleSearchChange}
                        />
                      )}
                    </FormGroup>
                  ))}
                  <FormGroup>
                    <Button bsStyle="primary" type="submit">
                      Search
                    </Button>
                    <Button
                      bsClass="btn btn-outline-secondary"
                      type="button"
                      onClick={this.resetSearch}
                      style={{ marginLeft: "10px" }}
                    >
                      Reset
                    </Button>
                  </FormGroup>
                </form>
              </div>
              <div className="right">{this.renderSearchResults()}</div>
            </div>
          )}
        </div>
        <Popup
          contentStyle={{
            width: "95%",
            borderRadius: "15px",
            padding: "15px",
          }}
          open={this.state.viewerOpen}
          modal
          closeOnDocumentClick={false}
          onClose={this.closeViewer}
        >
          <div>
            {/* eslint-disable-next-line */}
            <a className="close" onClick={this.closeViewer}>
              &times;
            </a>
            <iframe
              id="imageViewer"
              src={config.ImageViewer}
              title="Image Viewer"
              style={{ width: "100%", height: "90vh" }}
            ></iframe>
          </div>
        </Popup>
        <footer
          style={{ position: "fixed", bottom: "2%", right: "0", margin: "5px" }}
        >
          <span>Powered by&nbsp;&nbsp;</span>
          <img src={DocumentSync} alt="DocumentSync" width="200px" />
        </footer>
      </Fragment>
    );
  }
}
